import { CounterModern } from '../counterModern';

export const InputLimit = ({
    selected,
    setSelected,
    min = 0,
    max = 500,
    disabled = false,
    label = 'Límite de alumnos',
    hint,
    error = null,
    required = false,
    onChange,
}) => (
    <div className="w-full">
        <CounterModern
            id="course-limit-members"
            label={label}
            editable
            value={Number(selected?.limitMembers) || 0}
            onChange={(next) => {
                onChange?.();
                setSelected((prev) => ({
                    ...prev,
                    limitMembers: next,
                }));
            }}
            min={min}
            max={max}
            disabled={disabled}
            required={required}
            error={error}
            aria-label={label}
        />
        {hint ? (
            <p className="mt-1.5 text-xs text-slate-500">{hint}</p>
        ) : null}
    </div>
);
